interface AgentDetailPlaceholderTabProps {
  label: string;
}

export const AgentDetailPlaceholderTab = ({ label }: AgentDetailPlaceholderTabProps) => (
  <div className="mx-auto flex max-w-3xl flex-col gap-3">
    <h2 className="text-2xl font-semibold">{label}</h2>
    <div className="flex flex-col items-center justify-center gap-2 py-16 text-center">
      <p className="text-sm text-muted-foreground">{label} coming soon</p>
    </div>
  </div>
);
